
import usersGetters from './getters/usersGetters'
import siteGetters from './getters/siteGetters'
import vouchersGetters from './getters/vouchersGetters'
import selectedProductGetters from './getters/selectedProductGetters'

export default {
    ...siteGetters,
    ...selectedProductGetters,
    ...usersGetters,
    ...vouchersGetters,
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/getters.js